export enum ChartType {
  UPTIME = 'uptime',
  UPTIMEFULL = 'uptimeFullReport',
  TEMP = 'temp',
  TEMPFULL = 'tempFullReport',
  CPU = 'cpu',
  CPUFULL = 'cpuFullReport',
}
